export const headers = (token: string, includeContentType: boolean = true) => {
  return {
    ...(includeContentType ? { 'Content-Type': 'application/json' } : {}),
    Accept: 'application/json',
    'X-CSRF-Token': token
  }
}
